import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IEGColorTransform } from '@tencent/slide-sdk-model';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { alphaToEmu, emuToAlpha } from '@src/slide/infrastructure/module/independent/unit';
import { NullableDeep } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';

/**
 * 颜色属性转换
 */
export class ColorTransformConverter {
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<IEGColorTransform[]>>,
        uiData: ITDColor,
    ) {
        if (sdkData.length) {
            sdkData.forEach((egColorTransform) => {
                if (egColorTransform?.lumOff) {
                    uiData.lumOff = egColorTransform.lumOff.val;
                }

                if (egColorTransform?.lumMod) {
                    uiData.lumMod = egColorTransform.lumMod.val;
                }

                if (egColorTransform?.alpha) {
                    uiData.alpha = emuToAlpha(egColorTransform.alpha.val ?? 100000);
                }

                // tint、shade...
                if (egColorTransform?.shade) {
                    uiData.shade = egColorTransform.shade.val;
                }

                if (egColorTransform?.tint) {
                    uiData.tint = egColorTransform.tint.val;
                }
            });
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<ITDColor>>,
        sdkData: DeepPartial<NullableDeep<IEGColorTransform>[]>,
    ) {
        // mod和off的插入顺序会影响渲染结果，这两个一个是绝对值，一个是相对值，所以计算的先后会产生亮度影响
        // 亮度
        if (uiData?.lumMod) {
            const egColorTransform = {
                lumMod: {
                    val: uiData.lumMod,
                },
            };
            sdkData.push(egColorTransform);
        }

        // 亮度
        if (uiData?.lumOff) {
            const egColorTransform = {
                lumOff: {
                    val: uiData.lumOff,
                },
            };
            sdkData.push(egColorTransform);
        }

        // shade
        if (uiData?.shade) {
            const egColorTransform = {
                shade: {
                    val: uiData.shade,
                },
            };
            sdkData.push(egColorTransform);
        }

        // tint
        if (uiData?.tint) {
            const egColorTransform = {
                tint: {
                    val: uiData.tint,
                },
            };
            sdkData.push(egColorTransform);
        }

        // 透明度
        // 默认alpha为一个getter，但部分地方深拷贝可能会导致TdColor还原为普通对象，则需originAlpha兜底
        const alpha = uiData?.alpha ?? uiData?.originAlpha;
        const alphaEgColorTransform = {
            alpha: {
                val: alpha === 0 ? 0 : Math.round(alphaToEmu(alpha || 1)),
            },
        };
        sdkData.push(alphaEgColorTransform);
    }
}
